<div [ngStyle]="divStyle" [innerHTML]="isMobile ? mobileText : nativeText"
style="position:absolute; z-index:50; color:#fbb199;"></div>
